import { Box, Dialog, DialogActions, DialogContent, MenuItem, Typography } from '@mui/material';
import { CustomButton, CustomTextField, CustomSelect } from '../../../../../common/components';

const AdditionalDialog = ({
  additionalDialogOpen,
  editModeAdditional,
  selectedAdditional,
  additionals,
  editDescription,
  handleCloseAdditionalDialog,
  handleInputChangeAdditional,
  handleSaveAdditional,
}) => {
  return (
    <Dialog open={additionalDialogOpen} onClose={handleCloseAdditionalDialog} maxWidth={false}>
      <Box sx={{ p: 2, borderBottom: '2px solid #5e894f', backgroundColor: '#f2f2f2' }}>
        <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#5e894f', textAlign: 'center' }}>
          {editModeAdditional ? 'EDITAR ADICIONAL' : 'AGREGAR ADICIONAL'}
        </Typography>
      </Box>

      <DialogContent sx={{ display: 'flex' }}>
        <Box>
          <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
            <Box sx={{ width: '300px' }}>
              <CustomSelect
                name="uuid"
                label="Descripción"
                value={selectedAdditional.additional?.uuid || 0}
                onChange={handleInputChangeAdditional}
                sx={{ marginTop: 1, marginBottom: 0.5 }}
              >
                <MenuItem value={0}>Seleccionar</MenuItem>
                {additionals.map((additional) => (
                  <MenuItem key={additional.uuid} value={additional.uuid}>
                    {additional.name}
                  </MenuItem>
                ))}
              </CustomSelect>
              <CustomTextField
                margin="dense"
                name="amount"
                label="Importe"
                type="number"
                fullWidth
                value={selectedAdditional.amount || ''}
                onChange={handleInputChangeAdditional}
              />
            </Box>

            <Box sx={{ width: '20px' }} />

            <Box sx={{ width: '300px' }}>
              <CustomTextField
                disabled
                margin="dense"
                name="current_fee"
                label="Cuota Actual"
                fullWidth
                value={selectedAdditional.current_fee || ''}
              />
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <CustomTextField
                  disabled
                  margin="dense"
                  name="initial_fee"
                  label="Cuota Inicial"
                  fullWidth
                  value={selectedAdditional.initial_fee || ''}
                />
                <Box sx={{ fontSize: '30px', marginX: 1 }}>/</Box>
                <CustomTextField
                  disabled
                  margin="dense"
                  name="final_fee"
                  label="Cuota Final"
                  fullWidth
                  value={selectedAdditional.final_fee || ''}
                />
              </Box>
            </Box>
          </Box>
          <CustomTextField
            disabled={!editDescription}
            margin="dense"
            name="description"
            label="Detalle"
            fullWidth
            value={selectedAdditional.description || ''}
            onChange={handleInputChangeAdditional}
          />
        </Box>
      </DialogContent>

      <DialogActions sx={{ p: 2, borderTop: '1px solid #e0e0e0' }}>
        <CustomButton onClick={handleCloseAdditionalDialog} variant="text">
          Cancelar
        </CustomButton>
        <CustomButton onClick={handleSaveAdditional} variant="contained">
          Guardar
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default AdditionalDialog;
